import config from "../config";
import axios from "axios";
import StorageManager from "../utils/storageManager";
import verintService from "./clients/verintService";
import verintState from "../utils/verintState";

axios.create({
  baseURL: config.api_root,
  timeout: 5000,
  headers: {
    "x-access-token": localStorage.getItem("token"),
    "Content-Type": "application/json"
  }
});

// // Request interceptor that fetch's a Verint token on page refresh
let verintLoginPromise = null;

// Skip Verint for login/renew/token endpoints to avoid circular or too-early token calls.
const shouldSkipVerint = (requestConfig) => {

  const requestUrl = ((requestConfig && requestConfig.url) || "").toLowerCase();

  return requestUrl.includes("/auth/login")
    || requestUrl.includes("/auth/renew")
    || requestUrl.includes("/verint/gettoken");
};

axios.interceptors.request.use(async (requestConfig) => {
  if (config.use_verint === "false") {
    return requestConfig;
  }

  if (requestConfig.headers && requestConfig.headers.Authorization) {
    return requestConfig;
  }

  if (shouldSkipVerint(requestConfig)) {
    return requestConfig;
  }

  const carbuyJwt = StorageManager.getJWT('CarBuyServiceJWT');
  if (!carbuyJwt) return requestConfig;

  if (verintService.token || verintState.loginAttempted) return requestConfig;

  const store = require("../store").default || require("../store");
  if (!verintLoginPromise) {
    verintLoginPromise = store.dispatch('verintLogin').finally(() => {
      verintState.loginAttempted = true;
      verintLoginPromise = null;
    });
  }
  await verintLoginPromise;

  return requestConfig;
}, error => Promise.reject(error));

export default axios;



// WEBPACK FOOTER //
// ./src/api/resources.js